import { useTranslation } from 'react-i18next';
import { HpCardHeader } from '@hp/ui';
import { fmtInt } from '../../lib/format';
import { useLeadSettings } from './queries';

/** The steps of plan section 6 in plain words, in order (texts: `leads:general.explainer.steps.<step>`). */
const STEPS = ['duplicate', 'campaign', 'rule', 'target', 'person', 'owner', 'delivery'] as const;

/** Card "How a lead is routed": static steps; the only data is the current settings version. */
export function RoutingExplainer() {
  const { t } = useTranslation(['leads']);
  const settings = useLeadSettings();
  return (
    <section className="hp-card">
      <HpCardHeader
        title={t('general.explainer.title')}
        subtitle={
          settings.data
            ? t('general.explainer.version', { version: fmtInt(settings.data.version) })
            : t('general.explainer.subtitle')
        }
        icon="book"
      />
      <div className="hp-card__body">
        <ol className="bo-steps">
          {STEPS.map((step) => (
            <li key={step}>
              <span className="bo-strong">{t(`general.explainer.steps.${step}.title`)}</span>{' '}
              {t(`general.explainer.steps.${step}.body`)}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
